import { getServiceURL, requestHandler } from "../utils/apiUtils";

export class ListingsAPI {
  static get getListingsServiceName() {
    return "GET_LISTINGS";
  }

  static async getListings(params?: { param?: string }): Promise<object> {
    const url = getServiceURL(this.getListingsServiceName);
    const response = await requestHandler(url, params);
    return response?.data;
  }
}
